<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <Navbar></Navbar>
    <!-- <section class="promotion">
      <div class="promotion-box-wrap">
        <article class="promotion-box bg-color">
          <div class="promotion-box-block">
            <h3 class="title-2">熱門銷售 <span>Hot Products</span></h3>
            <ul class="stock">
              <li>
                <figure><img src="https://www.andyvh.com/chengyi/upload_files/product_34523088_o_1.jpg"></figure>
                <span class="note no-stock">推薦款</span>
                <a href="https://www.andyvh.com/chengyi/products.php?func=p_detail&amp;p_id=401&amp;pc_parent=63"> <span
                    class="post">傘型飯菜罩/不挑色/現貨~</span></a>
              </li>
              <li>
                <figure><img src="https://www.andyvh.com/chengyi/upload_files/product_34617119_o_1.jpg"></figure>
                <span class="note no-stock">推薦款</span>
                <a href="https://www.andyvh.com/chengyi/products.php?func=p_detail&amp;p_id=396&amp;pc_parent=62"> <span
                    class="post">可計數跳繩(預購/不挑色)預計8/5號到貨</span></a>
              </li>
              <li>
                <figure><img src="https://www.andyvh.com/chengyi/upload_files/product_34617403_o_1.jpg"></figure>
                <span class="note no-stock">推薦款</span>
                <a href="https://www.andyvh.com/chengyi/products.php?func=p_detail&amp;p_id=395&amp;pc_parent=62"> <span
                    class="post">冰絲百褶寬褲(預購/不挑色)預計7/30號到貨</span></a>
              </li>
              <li>
                <figure><img src="https://www.andyvh.com/chengyi/upload_files/product_34189086_o_1.jpg"></figure>
                <span class="note no-stock">推薦款</span>
                <a href="https://www.andyvh.com/chengyi/products.php?func=p_detail&amp;p_id=408&amp;pc_parent=63"> <span
                    class="post">奶昔健身搖搖杯/不挑色/現貨~</span></a>
              </li>
              <li>
                <figure><img src="https://www.andyvh.com/chengyi/upload_files/product_34263597_o_1.jpg"></figure>
                <span class="note no-stock">推薦款</span>
                <a href="https://www.andyvh.com/chengyi/products.php?func=p_detail&amp;p_id=404&amp;pc_parent=63"> <span
                    class="post">正版三麗鷗HELLO KITTY望遠鏡/不挑色/現貨~~~</span></a>
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>-->
    <!-- 輪播 -->
    <!-- <div
      id="carouselExampleIndicators"
      class="carousel slide mb-5"
      data-ride="carousel"
      data-pause="false"
      data-interval="5000"
    >
      <ol class="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          :data-slide-to="key"
          :class="{ active: key==0 }"
          v-for="(item , key) in carouselIMG"
          :key="item.id"
        ></li>
      </ol>
      <div class="carousel-inner">
        <div
          class="carousel-item carousel-bg-1 carousel-item-height bg-cover"
          v-for="(item , key) in carouselIMG"
          :key="item.id"
          :class="{ active: key==0 }"
        >
          <img :src="item" class="d-block w-100 img-index" alt />
        </div>
     
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>-->
    <!-- 
<div class="carousel slide mb-5">
  <div class="carousel-item-height bg-cover">
  <img :src="carouselIMG[0]" class="d-block w-100 img-index" alt />
  </div>
    </div>-->
    <div class="carousel-item-height mb-3">
      <img :src="carouselIMG[0]" class="img-index" alt />
    </div>

    <div class="row justify-content-end">
      <div class="col-md-4 col-10 pb-4">
        <table>
          <tr>
            <td colspan="3" class="pb-2">
              <div class="input-group">
                <input type="text" class="form-control" aria-label aria-describedby="basic-addon2"
                  v-model="searchInput" />
                <div class="input-group-append">
                  <button class="btn btn-success" type="button" @click="getProduct(1)">搜尋產品</button>
                </div>
                <button class="btn btn-secondary" type="button" @click="clear" v-if="searchInput">取消搜尋</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="dropdown sort pr-2">
                <button class="btn btn-secondary dropdown-toggle search-bottom" type="button" id="dropdownSortButton"
                  data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">{{sort == 'ASC'? '由低到高' : '由高到低'}}</button>
                <div class="dropdown-menu" aria-labelledby="dropdownSortButton">
                  <a class="dropdown-item arrow" :active="{'active':sort=='ASC'}" @click="sort = 'ASC'">由低到高</a>
                  <a class="dropdown-item arrow" :active="{'active':sort=='DESC'}" @click="sort = 'DESC'">由高到低</a>
                </div>
              </div>
            </td>
            <td>
              <div class="dropdown sort pr-2">
                <button class="btn btn-secondary dropdown-toggle search-bottom" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">{{orderby =='hots'? '依銷售排序':orderby =='type'? '依類別排序':orderby =='wholesale'? '依價格排序':'依上架日期排序'}}</button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item arrow" :active="{'active':orderby=='hots'}"
                    @click="orderby = 'hots'">依銷售排序</a>
                  <a class="dropdown-item arrow" :active="{'active':orderby=='type'}"
                    @click="orderby = 'type'">依類別排序</a>
                  <a class="dropdown-item arrow" :active="{'active':orderby=='wholesale'}"
                    @click="orderby = 'wholesale'">依價格排序</a>
                  <a class="dropdown-item arrow" :active="{'active':orderby=='reservation'}"
                    @click="orderby = 'reservation'">依上架日期排序</a>
                </div>
              </div>
            </td>
            <!-- <td>
              <button class="btn btn-info search-bottom mr-2" type="button" id="allButton" @click="clearSearch"
                v-if="type || middleType">搜尋全部分類</button>
            </td> -->
            <td class="productView">
              <div class="btn-group search-bottom" role="group" aria-label="Basic example">
                <button class="btn btn-outline-primary" :class="{disabled: this.productViewStatus==0}"
                  @click="changeStatus(0)"><i class="fas fa-th"></i></button>
                <button class="btn btn-outline-primary" :class="{disabled: this.productViewStatus==1}"
                  @click="changeStatus(1)"><i class="fas fa-list"></i></button>
              </div>
            </td>

          </tr>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2 index-sidebar">
        <!-- <nav class="index-sidebar2">
          <ul>
            <li class="arrow" :class="{ 'li_active2': searchShop == -1 }">
            
              <a role="button" @click="activateShop(-1)">流行商品區</a>
            </li>
            <li class="arrow">
              <router-link tag="a" to="/hotIndex">熱門商品區</router-link>
            </li>
            <li class="arrow">
              <router-link tag="a" to="/preOrder" v-if="user==1 || user==2">預購商品區</router-link>
            </li>
           
            <li class="arrow" v-if="shop == 1" :class="{ 'li_active2': searchShop == 2 }">
              <a role="button" @click="activateShop(2)">高級會員專區</a>
            </li>
            <li class="arrow" v-if="shop == 2" :class="{ 'li_active2': searchShop == 3 }">
              <a role="button" @click="activateShop(3)">代理專區</a>
            </li>
          </ul>
        </nav> -->

        <nav class="index-sidebar">
          <ul class="list-unstyled components">
            <li :class="{ 'li_active': active_all}"><a class="arrow" @click="GopreOrder">全部商品</a></li>
            <li v-for="(item , key) in typeview" :key="item.id" :class="{ 'li_active': active_el ==item.id }"
              v-show="typedisplay[key]">
              <span v-if="typedisplay[key]">
                <a role="button">
                  <span class="arrow" @click="searchType(item.id);activate(item.id)">{{item.type}}</span>
                  <span class="close" :class="{ 'close_active': open[item.id] }" @click="isopen(item.id)"
                    v-if="item.middletypes !=''"></span>
                </a>
                <ul class="list" v-if="open[item.id]">
                  <li v-for="item2 in item.middletypes" :key="item2.id"
                    :class="{ 'li_active2': active_el2 ==item2.id }">
                    <a role="button" class="arrow"
                      @click="searchmiddleType(item2.id);activate2(item2.id)">{{item2.middleType}}</a>
                  </li>
                </ul>
              </span>
            </li>
          </ul>
        </nav>
      </div>

      <div class="col-lg-10">
        <div class="tab-content" id="pills-tabContent" v-if="!productViewStatus">
          <div class="tab-pane fade show active" id="pills-sell" role="tabpanel" aria-labelledby="pills-sell-tab">
            <!-- 卡片項目 -->
            <div class="container">
              <div class="row productwid">
                <div class="col-lg-3 col-6 mb-5" v-for="(item , key) in products" :key="item.id">
                  <div class="card h-100 shadow">
                    <div class="card-body pb-0">
                      <img :src="imgUrl[key]" class="card-img-top" alt="product-image" />
                      <div class="card-title ellipsis">{{item.name}}</div>
                      <div class="card-title2">{{item.prompt}}</div>
                    </div>
                    <div class="card-footer pt-0" v-if="token">
                      <!-- <p class="text-right text-muted mb-0">
										<del>原價：{{item.price | currency}}</del>
                      </p>-->

                      <span v-if="admin=='1'">
                        <p class="card-price text-right mb-0" v-if="item.wholesale">
                          實際成本價：<span class="card-pricecontent">{{item.options[0].realCost | currency}}</span></p>
                        <p class="card-price text-right mb-0" v-else>實際成本價：<span
                            class="card-pricecontent">{{item.productRealCost | currency}}</span></p>
                      </span>

                      <span v-if="shop=='1' || shop=='2'">
                        <p class="card-price text-right mb-0" v-if="item.wholesale"><span
                            v-if="!item.preOrder">成本價：<span
                              class="card-pricecontent">{{item.options[0].cost | currency}}</span></span></p>
                        <p class="card-price text-right mb-0" v-else><span v-if="!item.preOrder">成本價：<span
                              class="card-pricecontent">{{item.productCost | currency}}</span></span></p>
                      </span>

                      <p class="card-price text-right mb-0" v-if="item.wholesale">
                        批發價：<span class="card-pricecontent">{{item.options[0].wholesale | currency}}</span>
                      </p>
                      <p class="card-price text-right mb-0" v-else>批發價：<span
                          class="card-pricecontent">{{item.price | currency}}</span></p>
                      <span v-if="!item.preOrder">
                        <p class="card-price text-right mb-0 mt-2" style="color:gray" v-if="item.options!=null">
                          庫存量：
                          <span v-for="(item2 , index) in item.options" :key="index.id">
                            {{item.options[index].quantityLimit}}
                            <span v-if="item.options.length-1!=index">;</span>
                          </span>
                        </p>
                        <p class="card-price text-right mb-0 mt-2" style="color:gray" v-else>庫存量：{{item.limitNum}}</p>
                      </span>
                    </div>
                    <div class="card-footer pt-0 pb-4" v-else>
                      <p class="card-price text-right mb-0">批發價：<span class="card-pricecontent">?</span></p>
                      <p class="card-price text-right mb-0" style="color:gray">庫存量：?</p>
                    </div>

                    <div class="card card-content my-bg-primary text-white arrow"
                      @click.prevent="productDetail(item.id)">
                      <div class="card-header h-25 pt-4"></div>
                      <div class="card-body text-white">
                        <h4 class="card-title">{{item.name}}</h4>
                      </div>
                      <!-- <div class="card-footer d-flex flex-column">
                    <div class="row justify-content-center cardborder">
                      <div class="col-6">
												<a href="#" @click.prevent="addtoCart(item.id)">
													<i class="fas fa-cart-plus icon-big"></i>
												</a>
                      </div>
                      <div class="col-12 mt-3" >
                        <a href="#" @click.prevent="productDetail(item.id)">
                          <i class="fas fa-search-plus icon-big"></i>
                        </a>
                      </div>
                    </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="table mt-3" v-else>
          <thead>
            <th width="50" class="text-center">產品圖片</th>
            <th width="200" class="text-center">產品名稱</th>
            <th width="130" class="text-center" v-if="admin=='1' &&token">實際成本價</th>
            <th width="100" class="text-center" v-if="(shop=='1' || shop=='2') &&token">成本價</th>
            <th width="100" class="text-center">批發價</th>
            <!-- <th width="100">訂單數</th>
        <th width="100">銷售量</th>
        <th width="150">銷售總金額</th> -->
            <th width="150" class="text-center">庫存量</th>
            <!-- <th width="120">是否上架</th> -->

          </thead>
          <tbody v-if="token">
            <tr v-for="(item ,key) in products" :key="item.id" @click="productDetail(item.id)" class="arrow">
              <td class="text-center">
                <img class="img-fluid" alt :src="imgUrl[key]" width="35%" />
              </td>
              <td>{{item.name}}</td>
              <td class="text-center" v-if="admin=='1' &&token">
                <span v-if="item.wholesale">
                  <span class="card-pricecontent">{{item.options[0].realCost | currency}}</span></span>
                <span v-else><span class="card-pricecontent">{{item.productRealCost | currency}}</span></span>
              </td>

              <td v-if="shop=='1' || shop=='2'" class="text-center">
                <span v-if="item.wholesale"><span
                    v-if="!item.preOrder"><span class="card-pricecontent">{{item.options[0].cost | currency}}</span></span></span>
                <span v-else><span v-if="!item.preOrder"><span class="card-pricecontent">{{item.productCost | currency}}</span></span></span>
              </td>

              <td class="text-center" v-if="item.wholesale">
                <span class="card-pricecontent">{{item.options[0].wholesale | currency}}</span></td>
              <td class="text-center" v-else><span class="card-pricecontent">{{item.price | currency}}</span></td>


              <td v-if="!item.preOrder">
                <p class="h6 text-center mb-0 mt-2" style="color:gray" v-if="item.options!=null">

                  <span v-for="(item2 , index) in item.options" :key="index.id">
                    {{item.options[index].quantityLimit}}
                    <span v-if="item.options.length-1!=index">;</span>
                  </span>
                </p>
                <p class="h6 text-center mb-0 mt-2" style="color:gray" v-else>{{item.limitNum}}</p>
              </td>

            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(item ,key) in products" :key="item.id" @click="productDetail(item.id)" class="arrow">
              <td class="text-center">
                <img class="img-fluid" alt :src="imgUrl[key]" width="35%" />
              </td>
              <td>{{item.name}}</td>

              <td class="text-center"> <span class="card-pricecontent">?</span></td>

              <td class="text-center">
               ?
              </td>

            </tr>
          </tbody>
        </table>

        <div class="row justify-content-center">
          <div class="row mt-4 justify-content-center">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="getProduct(1)">
                  <span class="fas fa-angle-double-left"></span>
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" aria-label="Previous"
                  @click.prevent="(now-pageSize<=0)?'':getProduct(now-pageSize)">
                  <span class="fas fa-chevron-left"></span>
                </a>
              </li>

              <li class="page-item" v-if="4<current">
                <a class="page-link" href="#">
                  <span class="fas fa-ellipsis-h"></span>
                </a>
              </li>

              <li class="page-item" :class="{active:current === page}" v-for="page in Math.ceil(total/pageSize)">
                <a class="page-link" href="#" @click.prevent="getProduct((page-1)*pageSize+1)"
                  v-if="page<current+4 && page>current-4">{{page}}</a>
              </li>

              <li class="page-item" v-if="Math.ceil(total/pageSize)>4 && Math.ceil(total/pageSize)-4>=current">
                <a class="page-link" href="#">
                  <span class="fas fa-ellipsis-h"></span>
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" aria-label="Next"
                  @click.prevent="(now+pageSize>total)?'':getProduct(now+pageSize)">
                  <span class="fas fa-chevron-right"></span>
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" aria-label="Previous"
                  @click.prevent="getProduct(total%pageSize==0?total-pageSize+1:parseInt(total/pageSize)*pageSize+1)">
                  <span class="fas fa-angle-double-right"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import axios from "axios";
  import Navbar from "../../components/Layout/Navbar";
  import Footer from "../../components/Layout/Footer";

  export default {
    components: {
      Navbar,
      Footer
    },
    name: "index",
    data() {
      return {
        isLoading: false, //加入讀取效果
        token: localStorage.getItem("usertoken"),
        currentCategory: "全部商品",
        category: [
          "全部商品",
          "DSLR單反相機",
          "DSLR單反鏡頭",
          "EVIL無反相機",
          "EVIL無反鏡頭"
        ],
        sort: "DESC", //排序
        orderby: "reservation", //排序
        shopId: 49,
        limitNum: [],
        singlePageData: [],
        type: '', //搜尋分類
        middleType: '', //搜尋子分類
        selectType: '', //從商品詳細頁面選擇子分類要跳轉首頁暫存類別ID
        current: 1, //當前頁數
        now: 1, //現在筆數
        pageSize: 30, //每頁筆數
        total: 0, //總筆數
        products: [], //儲存產品
        imgUrl: [], //存圖片網址
        filterProducts: [], //去除掉未上架商品
        carousel: [], //儲存輪播所有資料
        carouselIMG: [], //儲存輪播圖片
        searchInput: "", //搜尋
        open: [],
        typeview: "",
        active_all: true, //全部分類
        active_el: "", //第一層
        active_el2: "", //第二層
        searchShop: -1, //權限區
        shop: 0, //會員權限
        admin: 0, //是不是管理員
        user: '',
        typedisplay: [], //判斷依身分登入顯示的分類
        productViewStatus: 0, //產品顯示狀態
      };
    },
    methods: {
      GopreOrder(){
        this.$router.push('/preOrder');
      },
      //更改產品顯示狀態
      changeStatus(status) {
        this.productViewStatus = status;
      },
      //會員權限
      activateShop(id) {
        this.searchShop = id;
      },
      //第一層分類
      activate(id) {

        this.active_el = parseInt(id);
        this.active_all = false;
        this.active_el2 = "";
      },
      //第二層分類
      activate2(id) {
        this.active_el2 = parseInt(id);
        this.active_all = false;
        this.active_el = "";
      },
      //清除搜尋
      clear() {
        this.searchInput = "";
        this.getProduct(1);
      },
      //清出篩選
      clearSearch() {
        localStorage.removeItem("middleType");
        localStorage.removeItem("type");
        this.active_all = true;
        this.type = "";
        this.middleType = "";
        this.active_el = "";
        this.active_el2 = "";
        this.getProduct(1);
      },

      isopen(key) {

        this.$set(this.open, key, !this.open[key]);
      },
      searchType(id) {
        localStorage.setItem("type", id);
        this.type = localStorage.getItem("type");
        this.middleType = "";
        localStorage.removeItem('middleType');
        this.getProduct(1);
      },
      searchmiddleType(id) {
        localStorage.setItem("middleType", id);
        this.middleType = localStorage.getItem("middleType");
        this.type = "";
        localStorage.removeItem('type');
        this.getProduct(1);
      },
      //取得權限
      getMe() {
        const vm = this;
        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };
        const data = {};
        const me_api = `${process.env.APIPATH}/me`;
        axios
          .post(me_api, data, headers)
          .then(res => {
            if (res.data.shop == undefined) {
              vm.shop = 0
            } else {
              vm.shop = res.data.shop;
            }
            vm.admin = res.data.admin;

            vm.getProduct();
          })
          .catch(err => {
            console.log(err);
          });
      },
      getType() {
        let vm = this;
        vm.isLoading = true;
        const data = {
          now: 1,
          limit: 20000
        };

        const me_api = `${process.env.APIPATH}/getAllType`;
        axios
          .post(me_api, data)
          .then(res => {
            vm.isLoading = false;
            vm.typeview = res.data.data;
            var arr = Object.keys(vm.typeview);
            var len = arr.length;
            for (let i = 0; i < len; i++) {
              // vm.open[i] = false;

              if (vm.shop == '0') {
                if (vm.typeview[i].type == '加盟店專用-開團商品專用區') {
                  vm.typedisplay[i] = false
                } else if (vm.typeview[i].type == '熱門產品現貨區-代理團媽專屬') {
                  vm.typedisplay[i] = false
                } else if (vm.typeview[i].type == '代理專區') {
                  vm.typedisplay[i] = false
                } else {
                  vm.typedisplay[i] = true
                }
              } else if (vm.shop == '1') {
                if (vm.typeview[i].type == '代理專區') {
                  vm.typedisplay[i] = false
                } else {
                  vm.typedisplay[i] = true
                }
              } else if (vm.shop == '2') {
                vm.typedisplay[i] = true
              }

            }

            //從詳細商品頁面點選分類或是子分類，要跳轉到首頁
            if (vm.type) {
              vm.activate(vm.type);
              vm.searchType(vm.type);
            }
            if (vm.middleType) {
              vm.activate2(vm.middleType);
              vm.searchmiddleType(vm.middleType);
              vm.isopen(vm.selectType);
            }




          })
          .catch(err => {
            console.log(err);
          });
      },
      //取得商品資料
      getProduct(start) {
       
        let vm = this;
        vm.isLoading = true;

        if (!start) start = vm.now;

        let data = {
          now: start,
          limit: vm.pageSize,
          orderby: vm.orderby,
          sort: vm.sort,
          key: vm.searchInput,
          filter: "PreOrder",
          // shop: vm.searchShop
        };

        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };
        vm.middleType = localStorage.getItem('middleType');
        vm.type = localStorage.getItem('type');
        // localStorage.removeItem('verificationEmail');
        //搜尋分類
        if (vm.type) {
          data = {
            now: start,
            limit: vm.pageSize,
            type: vm.type,
            orderby: vm.orderby,
            sort: vm.sort,
            filter: "Type",
            // shop: vm.searchShop
          };

        }

        //搜尋子分類
        if (vm.middleType) {
          data = {
            now: start,
            limit: vm.pageSize,
            middleType: vm.middleType,
            orderby: vm.orderby,
            sort: vm.sort,
            filter: "MiddleType",
            // shop: vm.searchShop
          };
        }
        let me_api = `${process.env.APIPATH}/productAll`;
        axios
          .post(me_api, data, headers)
          .then(res => {
            vm.isLoading = false;
            vm.products = res.data.data;
            this.imgUrl = [];
            if(vm.products){
               vm.products.forEach(item => {
              this.imgUrl.push(`${process.env.IMGPATH}/` + item.path);
            });
            }
           

            vm.total = res.data.total; //總筆數
            vm.now = start; //開始筆數
            vm.current = Math.ceil(vm.now / vm.pageSize); //計算頁數
          })
          .catch(err => {
            console.log(err);
          });
      },
      //加入購物車
      addtoCart(id) {
        let vm = this;
        vm.isLoading = true;

        const data = {
          id,
          qty: 1,
          shopId: vm.shopId
        };
     
        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };

        const api = `${process.env.APIPATH}/addCart`;
        axios
          .post(api, data, headers)
          .then(res => {
            const response = res.data;
            vm.isLoading = false;
            if (response.split(",")[0] == "okAdd") {
              alert("新增成功");
              vm.$bus.$emit("Navbar:updateCart");
              vm.getProduct();
            } else if (response == "noToken") {
              alert("請先登入帳號");
              this.$router.push(`/login`);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      //載入輪播
      getCarousel() {
        let vm = this;
        vm.isLoading = true;

        const data = {};

        const me_api = `${process.env.APIPATH}/getAllCarousel`;
        axios
          .post(me_api, data)
          .then(res => {
            vm.carousel = res.data; //輪播內容
            vm.carousel.forEach(item => {
              this.carouselIMG.push(
                `${process.env.INDEXIMGPATH}/` + item.picture
              );
            });

            vm.isLoading = false;
          })
          .catch(err => {
            alert("發現錯誤");
          });
      },
      //跳到商品詳細頁面
      productDetail(id) {
        this.$router.push(`/productDetailed/${id}`);
      },
      //抓取使用者資料
      getUser() {
        const vm = this;
        vm.isLoading = true;

        const headers = {
          headers: {
            'Authorization': 'Bearer ' + vm.token
          }
        };
        const data = {};
        const me_api = `${process.env.APIPATH}/me`;
        axios.post(me_api, data, headers)
          .then((res) => {
            vm.isLoading = false;
            vm.user = res.data.shop;

          })
          .catch((err) => {
            console.log(err)
          })

      },
    },
    created: function () {
      const vm = this;
      if (vm.$route.params.shopId) vm.shopId = parseInt(vm.$route.params.shopId);
      localStorage.setItem("shopId", vm.shopId);
      var t = setTimeout(function () {
        vm.$bus.$emit("Navbar:shopId", vm.shopId);
      }, 1000);

      vm.getMe();
      vm.getCarousel();
      vm.getUser();
      var t = setTimeout(function () {
        vm.getType();
        vm.middleType = localStorage.getItem('middleType');
        vm.type = localStorage.getItem('type');
        vm.selectType = localStorage.getItem('selectType');
      }, 1000); //因為伺服器跑很慢，所以設一個延遲時間




    },
    watch: {
      orderby: function () {
        this.getProduct(1);
      },
      sort: function () {
        this.getProduct(1);
      },
    },
    mounted() {
      //等舊元件銷毀才註冊
      const vm = this;

      vm.$bus.$on('Navbar:refreshCurrent', vm.clearSearch);
      vm.$bus.$on('Navbar:getbusProduct', vm.getProduct);
    },

  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .disabled {
    background-color: #007bff !important;
    color: #fff !important;
    opacity: 1 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/HelloWorld.vue